import { render, staticRenderFns } from "./FairCalendarForm.vue?vue&type=template&id=72fbb6bc&"
import script from "./FairCalendarForm.vue?vue&type=script&lang=js&"
export * from "./FairCalendarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports